export const invalidInputOutlineClasses = "outline outline-2 outline-ui-red";
const invalidInputBorderClasses = "border border-2 border-ui-red";
